import React from 'react'
import { HotBuyOrderList } from './list/page'

export const HotBuyOrdersPage = (): JSX.Element => {
  return <HotBuyOrderList></HotBuyOrderList>
}
